import ".././styles/Advertise.css";
import React, { useEffect, useState } from "react";
import poster from ".././assets/ads/ad_poster.png";

const PACKAGES = [
  {
    title: "Website Banner",
    price: "From $250 / month",
    details: ["Homepage rotation", "Clickable to your site", "Monthly reporting"],
  },
  {
    title: "Newsletter Feature",
    price: "From $150 / send",
    details: ["Placement in PCCM newsletter", "Link + CTA", "Community-facing messaging"],
  },
  {
    title: "Event Spotlight",
    price: "Custom",
    details: ["Event booth or screen placement", "Emcee mention", "Package add-ons available"],
  },
];

function Advertise() {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("/api/ads");
        const data = await res.json();
        if (Array.isArray(data.ads)) setAds(data.ads);
      } catch {
        setAds([]);
      }
    })();
  }, []);

  return (
    <div className="advertise-page">
      <div className="page-header advertise-hero" id="top">
        <div className="overlay"></div>
        <div className="container header-content">
          <h1>Advertise with PCCM</h1>
          <p>Reach a 90,000+ Filipino-Canadian audience in Manitoba and support community programs.</p>
          <div className="advertise-cta">
            <a href="mailto:president@thenewpccm.ca" className="btn btn-primary">Start a Conversation</a>
            <a href="/documents/WEBSITE_ADS_LETTER.pdf" className="btn btn-outline" target="_blank" rel="noreferrer">Download Media Sheet</a>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="ad-grid">
            <div className="card">
              <div className="card-content">
                <h3>Why advertise with us?</h3>
                <ul className="ad-benefits">
                  <li>90k+ Filipino-Canadians in Manitoba, 2.4k engaged on Facebook.</li>
                  <li>Homepage and event visibility to families, professionals, and newcomers.</li>
                  <li>Support a charitable centre while promoting your brand.</li>
                </ul>
              </div>
            </div>
            <div className="card highlight">
              <div className="card-content">
                <h3>Featured placements</h3>
                <p className="text-muted">Showcase your brand on-site and online.</p>
                <div className="feature-block">
                  <img src={poster} className="image" alt="Advertising poster" />
                  <div>
                    <p>Website carousel, newsletter features, and in-centre displays customized to your goals.</p>
                    <a href="/documents/WEBSITE_ADS_LETTER.pdf" className="btn btn-secondary btn-sm" target="_blank" rel="noreferrer">
                      View rate sheet
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2>Packages & add-ons</h2>
            <p className="text-muted">Select a package or bundle for cross-channel exposure.</p>
          </div>
          <div className="package-grid">
            {PACKAGES.map((pkg) => (
              <div key={pkg.title} className="card package-card">
                <div className="card-content">
                  <h3>{pkg.title}</h3>
                  <p className="price">{pkg.price}</p>
                  <ul>
                    {pkg.details.map((d) => (
                      <li key={d}>{d}</li>
                    ))}
                  </ul>
                  <a href="mailto:president@thenewpccm.ca" className="btn btn-primary btn-sm">Book this placement</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Current promotions</h2>
            <p className="text-muted">A sampling of banners submitted by our partners.</p>
          </div>
          <div className="ads-showcase">
            {ads.length ? (
              ads.map((ad) => (
                <a key={ad.id || ad.title} href={ad.link || "#"} target="_blank" rel="noreferrer" className="ad-showcase-card">
                  <img src={ad.image} alt={ad.title || "Sponsor graphic"} onError={(e) => { e.target.style.display = "none"; }} />
                  <div>
                    <h4>{ad.title || "Advertiser"}</h4>
                    <p className="text-muted">{ad.description}</p>
                  </div>
                </a>
              ))
            ) : (
              <p>No active promotions yet—be the first to feature your brand.</p>
            )}
          </div>
        </div>
      </section>

      <section className="section cta-row">
        <div className="container">
          <div className="card">
            <div className="card-content cta-flex">
              <div>
                <h3>Ready to promote your business?</h3>
                <p className="text-muted">Email us your goals and we’ll tailor a package that fits.</p>
              </div>
              <div className="cta-actions">
                <a href="mailto:president@thenewpccm.ca" className="btn btn-primary">Email PCCM</a>
                <a href="/documents/WEBSITE_ADS_LETTER.pdf" className="btn btn-outline" target="_blank" rel="noreferrer">Media Sheet</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Advertise;
